import type { ReactElement } from "react";

export const RecipesListGrid = ({ recipeCards }: { recipeCards: ReactElement[] }) => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 gap-y-14 max-w-5xl mx-auto pt-10 pb-12">
            {recipeCards}
        </div>
    );
};
